import TeacherCard from 'components/TeacherCard';
import { Empty } from 'zhs-components';
import CommonTitle from './CommonTitle.vue';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay, EffectCube } from 'swiper';
SwiperCore.use([Navigation, A11y, Autoplay, EffectCube]);
import 'swiper/swiper-bundle.min.css';
export default {
  components: {
    TeacherCard,
    Empty,
    CommonTitle,
    Swiper,
    SwiperSlide
  },
  props: {
    menu: Object
  },

  created() {
    this.getTeacherList();
  },

  data() {
    return {
      currentIndex: 0,
      currentSlideIndex: 0,
      teacherList: [],
      dialogTeacherVisible: false,
      currentTeacher: {},
      isFirst: true,
      modules: [Navigation, A11y, Autoplay, EffectCube]
    };
  },

  methods: {
    async getTeacherList() {
      const list = await this.$http.getHomeTeachers({
        // num: this.menu.num,
        num: 999,
        menu_id: this.menu.menu_id
      }); // this.teacherList = list
      // let timesToRepeat = 1
      // let repeatedArray = Array(timesToRepeat)
      //   .fill()
      //   .map(() => [...list])
      // let arr = [].concat(...repeatedArray)
      // const convertTo2D = arr =>
      //   Array.from({ length: Math.ceil(arr.length / 4) }, (_, i) => arr.slice(i * 4, i * 4 + 4))

      console.log(222333, list);
      this.teacherList = list; //convertTo2D(arr)
    },

    handleMore() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      let nav = navItemInfo.find(item => item.function_id == '18300');

      if (nav) {
        window.location.href = `/teacherList.html?menuId=${nav.id}&name=${nav.nav_name}&tab=${this.menu.menu_id}`;
      }
    },

    handleSlideChange(swiper) {
      console.log(1122, swiper);

      if (this.isFirst) {
        this.isFirst = false;
        return;
      }

      if (this.currentSlideIndex == this.teacherList.length - 1 && swiper.realIndex == 0) {
        this.currentIndex = 0;
        this.currentSlideIndex = swiper.realIndex;
        return;
      }

      if (this.currentSlideIndex == 0 && swiper.realIndex == this.teacherList.length - 1) {
        this.currentIndex = this.teacherList.length - 1;
        this.currentSlideIndex = swiper.realIndex;
        return;
      }

      if (this.currentSlideIndex - swiper.realIndex < 0) {
        this.currentIndex = this.currentIndex < this.teacherList.length - 1 ? this.currentIndex + 1 : 0;
        this.currentSlideIndex = swiper.realIndex;
      } else if (this.currentSlideIndex - swiper.realIndex > 0) {
        this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.teacherList.length - 1;
        this.currentSlideIndex = swiper.realIndex;
      } // this.currentIndex = this.currentIndex < this.teacherList.length - 1 ? this.currentIndex + 1 : 0  

    }

  }
};